import type {
  SquadsListResponse,
  SquadsQuery,
  SquadMe,
  SquadTagColors,
  Squad,
  SquadLogResponse,
  Race,
  RacePaginationResponse,
  Reward,
  RaceRatingResponse,
  Achievement,
  SquadAchievementsResponse,
  Settings
} from './types'

export const useSquadsApi = () => {
  const { $api } = useNuxtApp()

  return {
    fetchItems: (query: SquadsQuery = { page: 1, limit: 14 }) =>
      $api.get<SquadsListResponse>('/api/v1/squads', { query }),
    createSquad: (payload: FormData) =>
      $api.post<Squad>('/api/v1/squads', payload),
    changeSquad: (payload: FormData) =>
      $api.put<Squad>('/api/v1/squads/me', payload),
    fetchMeSquad: () => $api.get<SquadMe>('/api/v1/squads/me'),
    kickPersonSquad: (memberId: number) =>
      $api.post<''>(`/api/v1/squads/me/members/${memberId}/kick`),
    transferPersonSquad: (memberId: number) =>
      $api.post<''>(`/api/v1/squads/me/members/${memberId}/transfer`),
    leaveFromSquad: () =>
      $api.post<''>(`/api/v1/squads/me/leave`, undefined, {
        enableGlobalError: true
      }),
    deleteSquad: () => $api.delete<''>(`/api/v1/squads/me`),
    joinSquad: (id: number) =>
      $api.post<Squad>(`/api/v1/squads/${id}/join`, undefined, {
        enableGlobalError: true
      }),
    fetchTagColors: () =>
      $api.get<SquadTagColors[]>('/api/v1/squads/tag-colors'),
    fetchSquadById: (id: string) => $api.get<Squad>(`/api/v1/squads/${id}`),
    fetchLogsSquad: (query?: { page?: number }) =>
      $api.get<SquadLogResponse>(`/api/v1/squads/me/logs`, {
        query
      }),
    fetchSquadAchievementsById: (id: string) =>
      $api.get<SquadAchievementsResponse>(`/api/v1/squads/${id}/achievements`),
    fetchSquadSettings: () => $api.get<Settings>(`/api/v1/squads/settings`),
    fetchRacesActive: () => $api.get<Race>(`/api/v1/squads/races/active`),
    fetchRacesFinished: (query?: { page?: number }) =>
      $api.get<RacePaginationResponse>(`/api/v1/squads/races/finished`, {
        query
      }),
    fetchRacesFinishedById: (id: string) =>
      $api.get<Race>(`/api/v1/squads/races/${id}/finished`),
    fetchRacesUpcoming: () => $api.get<Race>(`/api/v1/squads/races/upcoming`),
    fetchRaceRatingById: ({ id, page }: { id: number; page: number }) =>
      $api.get<RaceRatingResponse>(`/api/v1/squads/races/${id}/rating`, {
        query: {
          page
        }
      }),
    fetchRaceRewardsById: (id: number) =>
      $api.get<Reward[]>(`/api/v1/squads/races/${id}/rewards`),
    fetchRaceAchievementsById: (id: number) =>
      $api.get<Achievement[]>(`/api/v1/squads/races/achievements`)
  }
}

export type {
  Squad,
  SquadAchievementsResponse,
  SquadAvatar,
  SquadsQuery,
  SquadsListResponse,
  SquadsLinks,
  SquadLink,
  SquadMe
} from './types'
